var React = require('react');

function MenuLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.995178 0H11L11 1.99039H0.995179L0.995178 0Z","fill":"white","key":0}),React.createElement("path",{"d":"M0.995178 7.00456H20.9952V8.99495H0.995179L0.995178 7.00456Z","fill":"white","key":1}),React.createElement("path",{"d":"M0.995178 14.0096L0.995179 16H14.9981V14.0096H0.995178Z","fill":"white","key":2})]);
}

MenuLeftInline.defaultProps = {"width":"21","height":"16","viewBox":"0 0 21 16","fill":"none"};

module.exports = MenuLeftInline;

MenuLeftInline.default = MenuLeftInline;
